import { t } from '@lingui/core/macro';
import { useSearchContext } from 'app/domains/global-search';
import { QueryField } from 'shared/domains/forms';
import { withFilterErrorBoundary } from '../FilterErrorBoundary';
export const QueryFilter = withFilterErrorBoundary((props) => {
    const { placeholder, action } = props;
    const { setQuery, clearQuery, values } = useSearchContext();
    const { query } = values;
    const defaultPlaceholder = t({ message: 'Search', comment: 'Insights: Query filter placeholder' });
    const handleSetQuery = (event) => {
        setQuery(event.target.value);
    };
    return (<QueryField value={query} onChange={handleSetQuery} placeholder={placeholder || defaultPlaceholder} onClear={clearQuery} action={action}/>);
});
